// ----------------------------------------------------------------------

export default function CssBaseline() {
    return {
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box',
                },
                '.recharts-wrapper': {
                    outline: 'none !important',
                },
                '.recharts-wrapper:focus': {
                    outline: 'none !important',
                },
                '.recharts-wrapper:focus-visible': {
                    outline: 'none !important',
                },
                '.recharts-surface': {
                    outline: 'none !important',
                },
                '.recharts-surface:focus': {
                    outline: 'none !important',
                },
                '.recharts-surface:focus-visible': {
                    outline: 'none !important',
                },
                '.recharts-sector:focus': {
                    outline: 'none',
                },
                '.recharts-sector:focus-visible': {
                    outline: 'none',
                },

                /* SVG paths inside charts */
                'svg path:focus': {
                    outline: 'none',
                },
                'svg path:focus-visible': {
                    outline: 'none',
                },
                html: {
                    width: '100%',
                    height: '100%',
                    WebkitOverflowScrolling: 'touch',
                },
                body: {
                    width: '100%',
                    height: '100%',
                },
                '#root': {
                    maxWidth: '1440px',
                    margin: '0 auto',
                    maxHeight: '665px',
                    // width: '100%',
                    // height: '100%',
                },
                textarea: {
                    backgroundColor: '#F3F3F5',
                    fontFamily: 'Inter,sans-serif',
                    border: '1px solid #E5E5E5',
                    borderRadius: '4px',
                    padding: '8px',
                    resize: 'none',
                    width: '100%',
                    '&:hover': {
                        border: '1px solid #F3F3F5',   // keep same border
                        backgroundColor: '#F3F3F5',    // keep same bg
                    },
                    '&:focus': {
                        outline: 'none',
                        border: '1px solid #F3F3F5',
                    },
                },

                input: {
                    '&[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                        '&::-webkit-inner-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                    },
                },
                img: {
                    display: 'block',
                    maxWidth: '100%',
                },
                '.ql-editor.ql-blank::before': {
                    fontStyle: 'normal',   // Remove italic
                    color: '#999999',      // Optional: light grey placeholder
                    fontSize: '12px',      // Optional: match editor font
                },

            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    fontSize: '12px',
                    color: '#717883',
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#FFFFFF', // odd rows → white
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#F9F9F9',
                    },

                    // all rows border
                    '& .MuiDataGrid-row': {
                        borderWidth: '0px 1px 1px 1px',
                        borderStyle: 'solid',
                        borderColor: '#EBEBEB',
                    },

                    // first row border (different color)
                    '& .MuiDataGrid-row:first-of-type': {
                        borderWidth: '0px 1px 1px 1px',
                        borderStyle: 'solid',
                        borderColor: '#E6E6E6',
                    },
                },
                columnHeaders: {
                    backgroundColor: '#FFF2F0',
                    fontSize: '12px',
                    color: '#374151',
                    fontWeight: 600,
                    border: '1px solid #E6E6E6',
                },
                cell: {
                    fontSize: '12px',
                    color: '#717883',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    border: 'none',
                },
            },
        }
    };
}
